var modules_4bba97ad = {"icon":"_utpes0"};
import "../../../../../assets/CjVfxIPW.css";

export { modules_4bba97ad as default };
//# sourceMappingURL=how-we-work-icon.module.scss.js.map
